import type { EditPayload, ChangeProposal } from "./edit-payload";

const VALID_OPERATIONS = new Set<string>(["replace", "insert", "delete", "format", "cross_ref", "insert_block"]);

export function validateEditPayload(input: unknown): EditPayload {
  if (input === null || typeof input !== "object" || Array.isArray(input)) {
    throw new Error("EditPayload must be an object");
  }

  const obj = input as Record<string, unknown>;

  if (!Object.prototype.hasOwnProperty.call(obj, "changes")) {
    throw new Error("EditPayload must have a 'changes' array");
  }
  if (!Array.isArray(obj.changes)) {
    throw new Error("EditPayload.changes must be an array");
  }

  const changes: ChangeProposal[] = obj.changes.map((item: unknown, idx: number) => {
    if (item === null || typeof item !== "object" || Array.isArray(item)) {
      throw new Error(`changes[${idx}] must be an object`);
    }
    const p = item as Record<string, unknown>;

    if (typeof p.id !== "string" || !p.id) {
      throw new Error(`changes[${idx}] missing required string 'id'`);
    }
    if (typeof p.paragraph_id !== "string") {
      throw new Error(`changes[${idx}] missing required string 'paragraph_id'`);
    }
    if (typeof p.operation !== "string" || !VALID_OPERATIONS.has(p.operation)) {
      throw new Error(
        `changes[${idx}] has invalid 'operation': ${String(p.operation)}. Must be one of: replace, insert, delete, format, cross_ref, insert_block`
      );
    }

    return item as ChangeProposal;
  });

  return { changes };
}
